import { FC, ReactNode } from "react";

interface ChatbotPreviewBackgroundProps {
  children: ReactNode;
}

export const ChatbotPreviewBackground: FC<ChatbotPreviewBackgroundProps> = ({
  children,
}) => (
  <div
    className="flex h-full w-full items-center justify-center bg-[#FEFFFF]"
    style={{
      backgroundImage:
        "radial-gradient(circle, #E1E4E6 1px, transparent 1.5px)",
      backgroundSize: "20px 20px",
    }}
  >
    {children}
  </div>
);
